export default __webpack_public_path__ + "static/ups_b.78108c77ff9f6b4b8fc05dd0733e1821.png";